import { Config, ConfigService } from '@services/config.service';
import { LocationSelectorService } from '@services/location_selector.service';
import type { UnitNode } from '@services/unit.service';
import { useService } from '@visiba/instantiation';
import { useEffect, useState } from 'react';

export function useSelectedEntrance(): [entrance: UnitNode | null, entranceConfig: Config | null] {
	const locationSelectorService = useService(LocationSelectorService);
	const configService = useService(ConfigService);
	const [locatedEntrance, setLocatedEntrance] = useState<UnitNode | null>(getInitialEntrance());
	const [loadedEntranceConfig, setLoadedEntranceConfig] = useState<Config | null>(getInitialEntranceConfigValue());

	function getInitialEntrance(): UnitNode | null {
		try {
			return locationSelectorService.entrance;
			// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
		} catch (error: unknown) {
			return null;
		}
	}

	function getInitialEntranceConfigValue(): Config | null {
		try {
			if (locationSelectorService.entrance) {
				return configService.getConfig(locationSelectorService.entrance.id);
			}

			return null;
			// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
		} catch (error: unknown) {
			return null;
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: suppressed due to migration - should be fixed
	useEffect(() => {
		function handleCommit(_: number): void {
			const entrance = locationSelectorService.entrance;
			const config = entrance ? configService.getConfig(entrance?.id) : null;

			// Don't know if React got a bug here but using the hook in multiple
			// places didn't work. The handler interrupted each other, don't really
			// know why.
			// thinking of ignoring setState and use a force updater instead...
			queueMicrotask(() => {
				setLocatedEntrance(entrance);
				setLoadedEntranceConfig(config);
			});
		}

		locationSelectorService.events.on('onCommitted', handleCommit);

		return () => {
			locationSelectorService.events.off('onCommitted', handleCommit);
		};
	}, [configService, locationSelectorService, locatedEntrance, loadedEntranceConfig]);

	return [locatedEntrance, loadedEntranceConfig];
}
